import { UtilS } from '@modules/Util/S/Function/module/UtilS.js';

export const BY_TAG = UtilS.isProd() ? 'https://byt.ag/' : 'https://stg.byt.ag/';
